import StopScroll from "./StopScrollClass";
import datepickerLanguage from "../storage/datapickerMultilanguage";

export default class Utils {

    static initial() {
        this.tabsInit();
        this.toggleInit();
        this.swipePopups();
        this.fadePopups();
        this.anchorScroll();
        this.pickerBetweenDate();
        this.customSelect();
        this.phoneMask();

        if(this.supportsWebp()) {
            $('html').addClass('webp')
        } else {
            $('html').addClass('no-webp')
        }

        this.stopScrollSwipe = null;
    }

    /**
     * Tabs
     */
    static tabsInit() {
        let $tabs = $('.tabs_wrap');

        $tabs.find('.tab_header').on('click', '.tab_menu:not(.active):not(.disabled)', function () {
            let $this = $(this),
                idContent = $(this).attr('data-id');

            $this.closest('.tab_header').find('.tab_menu').removeClass('active');
            $this.addClass('active');

            if(idContent) {
                let $content = $(this).closest('.tabs_wrap').find('.tab_content');
                $content.find(' > div').not($(idContent)).animate({opacity: 0}, 200, function() {
                    $content.find(' > div').not($(idContent)).hide();

                    $content.find(idContent).show();
                    $content.find(idContent).animate({opacity: 1}, 200);

                    //Update carousel if tab has it
                    if($content.find(idContent).find('.owl-carousel').length) {
                        //TODO: maybe not working
                        $content.find(idContent).find('.owl-carousel').trigger('refresh.owl.carousel');
                        // if(window.initProductCarousel) {
                        //     window.initProductCarousel.trigger('refresh.owl.carousel');
                        // }
                    }

                    // Dot dot dot
                    if($content.find(idContent).find('.dotdotdot').length) {
                        $(".dotdotdot").dotdotdot({
                            height: 60,
                            watch: 'window'
                        });
                    }
                })
            }
        })
    }

    /**
     * Toggles
     */
    static toggleInit() {
        let widowWidth = $(window).width();

        $(document).on('click', '.toggle_wrap .toggle_header', function () {
            let sizeInit = $(this).closest('.toggle_wrap').attr('data-toggle-size');
            if(!sizeInit || widowWidth <= Number(sizeInit)) {
                $(this).siblings('.toggle_content').slideToggle(200);
                $(this).toggleClass('open');
            }
        })
    }

    /**
     * Swipe popups
     */
    static swipePopups() {
        let self = this,
            $swipePopups = $('.open_swipe'),
            $overlayPage = $('.overlay_page'),
            $wrapSlide = $('.wrap_slide_popup');

        //open
        $swipePopups.on('click', function (e) {
            e.preventDefault();
            let id = $(this).attr('data-swipe'),
                nextStep = $(this).attr('data-step');

            if(!id && !nextStep) {
                console.warn('Please set data-swipe|data-step attribute');
                return false;
            }

            //Check if next step or open new window
            let scrollID = id ? id : nextStep;
            if(nextStep) {
                $(nextStep).css({transform: 'translate(0, 0)'});
            } else {
                $wrapSlide.css({transform: 'translate(100%, 0)'});
                $(id).css({transform: 'translate(0, 0)'});
                $overlayPage.fadeIn(200);
                setCloseOverlay(true);
            }

            self.stopScrollSwipe = new StopScroll($(scrollID), '.wrap_slide_popup', '.content');
            self.stopScrollSwipe.disableScroll();

        });

        //Close
        $wrapSlide.find('.header .icon-arrow_back, .header .icon-clear').on('click', function () {
            if($(this).attr('data-this')) {
                //Only this window
                $(this).closest('.wrap_slide_popup').css({transform:'translate(100%, 0)'});

                self.stopScrollSwipe = new StopScroll($('#categories_swipe'), '.wrap_slide_popup', '.content');
                self.stopScrollSwipe.disableScroll();
            } else {
                //All
                allClose();
            }
        });

        function setCloseOverlay(set) {
            if(set) {
                $overlayPage.bind('click', function () {
                    allClose()
                });
            } else {
                $overlayPage.unbind('click');
            }
        }

        function allClose() {
            $wrapSlide.css({transform:'translate(100%, 0)'});
            $overlayPage.fadeOut(100);
            setCloseOverlay(false);

            self.stopScrollSwipe.enableScroll();
        }
    }

    /**
     * Fade popup
     */
    static fadePopups() {
        let $popups = $('.wrap_fade_popup'),
            $overlayPage = $('.overlay_page');

        if($popups.length) {
            popupPosition();

            $(document).on('click', '.fade-popup', function (e) {
                e.preventDefault();
                let $this = $(this),
                    id = $(this).attr('data-fade');

                if(!id) {
                    console.warn('Please set data-fade attribute');
                    return false;
                }
                openPopup(id, $(this).attr('data-scroll-class'), $this.attr('data-focus'));
            });

            //Trigger position popups
            $(document).bind('trigger.position.popup', function (e, id, thisScrollClass, thisFocus) {
                popupPosition();
            });

            //Trigger show popup
            $(document).bind('trigger.show.popup', function (e, id, thisScrollClass, thisFocus) {
                openPopup(id, thisScrollClass, thisFocus);
            });


            //Close
            $popups.on('click', '.header .icon-clear, .close-popup', function (e) {
                e.preventDefault();
                allClose();
            });
        }

        function popupPosition() {
            console.log('Change position');
            //Position for all popup on desktop
            if ($(window).width() >= 1200) {

                let wW = $(window).width(),
                    wH = $(window).height();

                $popups.each(function () {
                    let blW = $(this).outerWidth(true),
                        blH = $(this).outerHeight(true);

                    $(this).css({
                        'left': (wW - blW) / 2,
                        'top': (wH - blH) / 2,
                    })
                });
            }
        }

        function openPopup(id, thisScrollClass, thisFocus) {
            $(id).fadeIn(200, function () {
                //Set autofocus on input
                if(thisFocus) {
                    let inputF = $(id).find('input[name='+ thisFocus +']');
                    if(inputF.length) {
                        inputF.focus();
                    } else {
                        console.warn('Input not found. Check input name!');
                    }
                }

                //Refresh trigger
                $('.fade-popup').trigger('fade.refresh.trigger');

            });
            $overlayPage.fadeIn(200);
            setCloseOverlay(true);


            if(thisScrollClass) {
                //Set other scroll area
                //data-scroll-class=".product_wrap" - need set to open btn
                self.stopScrollSwipe = new StopScroll($(id), '.wrap_fade_popup', thisScrollClass);
            } else {
                self.stopScrollSwipe = new StopScroll($(id), '.wrap_fade_popup');
            }

            self.stopScrollSwipe.disableScroll();
        }

        function setCloseOverlay(set) {
            if(set) {
                $overlayPage.bind('click.fade.popup', function () {
                    allClose()
                });
            } else {
                $overlayPage.unbind('click.fade.popup');
            }
        }

        function allClose() {
            $overlayPage.fadeOut(200);
            $popups.each(function () {
                let $eThis = $(this);
                $eThis.fadeOut(200, function () {
                    if($eThis.find('.thanks').length) {
                        $eThis.find('.thanks').fadeOut();
                        $eThis.find('form').fadeIn();
                    }
                });
            });
            setCloseOverlay(false);

            $('#confirm_delete').unbind('confirm:delete')
            if(self.stopScrollSwipe) {
                self.stopScrollSwipe.enableScroll();
            }

            //Reset form trigger
            $(document).trigger('fade.reset.form.popup');
        }

    }

    /**
     * Check webp
     * @returns {*}
     */
    static supportsWebp() {
        if (!self.createImageBitmap) return false;

        const iOS = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        if(iOS) return false;

        const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
        const blob = fetch(webpData).then(r => r.blob());
        return createImageBitmap(blob).then(() => true, () => false);
    }

    /**
     * Scroll to anchor
     */
    static anchorScroll() {
        $('a[href^="#"].anchor').on('click',function (e) {
            e.preventDefault();

            let padding = ($(this).attr('data-padding')) ? Number($(this).attr('data-padding')) : 0,
                target = this.hash,
                $target = $(target);

            $('html, body').stop().animate({
                'scrollTop': $target.offset().top - padding
            }, 300);
            //window.location.hash = target;
        });
    }

    /**
     * Pick date from and to
     */
    static pickerBetweenDate() {
        let $wrapPickerDates = $('.between_date_picker_wrap');

        $.datepicker.setDefaults(datepickerLanguage($('html').attr('lang')));
        $wrapPickerDates.each(function () {

            let $wrapPicker = $(this),
                $dFrom = $(this).find('input[name="date_from"]'),
                $dTo = $(this).find('input[name="date_to"]');

            if($dFrom.length && $dTo.length) {
                $dFrom.datepicker({
                    prevText: '<i class="icon icon-icon-triangle-left"></i>',
                    nextText: '<i class="icon icon-icon-triangle-right"></i>',
                    minDate: 1,
                    dateFormat: "dd.mm.yy",
                    onSelect: function () {
                        let minDate = $(this).datepicker('getDate');
                        setTimeout(function () {
                            minDate.setDate(minDate.getDate() + 1);
                            $dTo.datepicker('option', 'minDate', minDate);
                            setDateTo($dTo, $wrapPicker);
                        }, 300);
                        setDateFrom($dFrom, $wrapPicker);
                    }
                });
                readDateFrom($dFrom, $wrapPicker);
                setDateFrom($dFrom, $wrapPicker);

                $dTo.datepicker({
                    prevText: '<i class="icon icon-icon-triangle-left"></i>',
                    nextText: '<i class="icon icon-icon-triangle-right"></i>',
                    minDate: 2,
                    dateFormat: "dd.mm.yy",
                    onSelect: function () {
                        setDateTo($dTo, $wrapPicker);
                    }
                });
                readDateTo($dTo, $wrapPicker);
                setDateTo($dTo, $wrapPicker);
            }
        });

        function readDateFrom($dFrom, $wrapPicker) {
            let val = $wrapPicker.find('input[name="date_from"]').val();
            if (val) {
                $dFrom.datepicker('setDate', $.datepicker.parseDate('dd.mm.yy', val));
            } else {
                $dFrom.datepicker('setDate', 1);
            }
        }

        function readDateTo($dTo, $wrapPicker) {
            let val = $wrapPicker.find('input[name="date_to"]').val();
            if (val) {
                $dTo.datepicker('setDate', $.datepicker.parseDate('dd.mm.yy', val));
            } else {
                $dTo.datepicker('setDate', 2);
            }
        }

        function setDateFrom($dFrom, $wrapPicker) {
            let date = $dFrom.datepicker('getDate');
            let val = $.datepicker.formatDate('dd.mm.yy', date);
            $wrapPicker.find('input[name="date_from"]').val(val);
        }

        function setDateTo($dTo, $wrapPicker) {
            let date = $dTo.datepicker('getDate');
            let val = $.datepicker.formatDate('dd.mm.yy', date);
            $wrapPicker.find('input[name="date_to"]').val(val);
        }
    }

    /**
     * Custom select
     * data-value=true add filed for value
     */
    static customSelect() {

        let $dropDown = $('.drop_down');
        if($dropDown.length) {

            $dropDown.on('click', '.drop_down-list li:not(.active):not(.empty):not(.info)', function () {
                let value = $(this).html();
                $(this).parent().find('li').removeClass('active');
                $(this).addClass('active');

                $(this).closest('.drop_down').find('input:not([type=hidden])').val(value).addClass('full');
                $(this).closest('.drop_down').removeClass('open');

                //One more filed for data-value from li
                $(this).closest('.drop_down').find('input[type=hidden]').val($(this).attr('data-value'));
            });

            //For open after click
            $dropDown.find('input').on('click', function () {
                if($(this).closest('.drop_down').hasClass('disabled')) return false;
                $dropDown.not($(this).closest('.drop_down')).removeClass('open');
                $(this).closest('.drop_down').toggleClass('open');

                //Toggle focus
                if($(this).is(":focus") && !$(this).closest('.drop_down').hasClass('open')) {
                    $(this).blur();
                    checkSelect();
                } else {
                    $(this).focus();
                }
            });

            $(document).on('mouseup', function (e) {
                if ($dropDown.has(e.target).length === 0){
                    $dropDown.removeClass('open');
                    checkSelect();
                }
            });
        }

        //Clear value if user dosen`t selected or search was empty.
        function checkSelect() {
            $dropDown.each(function () {
                let $this = $(this);
                if($(this).find('.drop_down-list li.active').length === 0 ||
                    $(this).find('.drop_down-list li.empty').css('display') !== 'none') {

                    $(this).find('input').val('');
                    $(this).find('ul li').removeAttr('style').removeClass('active');
                    $(this).find('ul li.empty').css('display', 'none');
                }
            });
        }

        //Drop down search
        let $dropDownSearch = $('.drop_down_search');
        if($dropDownSearch.length) {
            $dropDownSearch.find('input').on('keyup', function () {

                let val = $(this).val().toLowerCase(),
                    $searchThis = $(this).closest('.drop_down_search').find('.drop_down-list li'),
                    found = 0;

                $searchThis.each(function () {
                    if(!$(this).hasClass('empty')) {
                        if ($(this).html().toLowerCase().indexOf(val) === -1) {
                            $(this).css('display', 'none');
                        } else {
                            $(this).removeAttr('style').removeClass('active');
                            found++;
                        }
                    }
                });

                if(found <= 0 && val.length > 0) {
                    $(this).closest('.drop_down_search').find('.drop_down-list li.empty').removeAttr('style');
                } else {
                    $(this).closest('.drop_down_search').find('.drop_down-list li.empty').css('display', 'none');
                }
            })
        }
    }

    /**
     * Phone mask
     */
    static phoneMask() {
        $('.phone_inputmask').inputmask('+38 (999) 999 99 99', {
            showMaskOnHover: false,
            "oncomplete": function(){
                $(this).addClass('completed');
            },
            "onincomplete": function () {
                $(this).removeClass('completed');
            },
        });
    }

    /**
     *
     * @param number
     * @param titles
     * @returns {*}
     */
    static declOfNum(number, titles) {
        const cases = [2, 0, 1, 1, 1, 2];
        return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
    }
}
